import { Logger } from './logger';
import { formatDate } from '@angular/common';

/**
 * a console logger implementation
 * all log will be write to the console
 * prepended with a timestamp
 */
export class ConsoleTimestampLogger extends Logger {
  constructor() {
    super();
  }

  log(message: any) {
    console.log(formatDate(Date.now(),'hh:mm:ss.SSS: ', 'en_UK').concat(message));
  }
  info(message: any) {
    // tslint:disable-next-line:no-console
    console.info(formatDate(Date.now(),'hh:mm:ss.SSS: ', 'en_UK').concat(message));
  }
  warn(message: any) {
    console.warn(formatDate(Date.now(),'hh:mm:ss.SSS: ', 'en_UK').concat(message));
  }
  debug(message: any) {
    // tslint:disable-next-line:no-console
    console.debug(formatDate(Date.now(),'hh:mm:ss.SSS: ', 'en_UK').concat(message));
  }
}
